import { useState, useEffect } from 'react';
import PromoBanner from '@/components/feature/PromoBanner';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Promo Banner */}
      <PromoBanner
        message="Offre spéciale :"
        highlight="-20% sur votre première intervention"
        link="#contact"
        linkText="Profiter de l'offre"
        bgColor="bg-gradient-to-r from-brand-500 to-teal-600"
        textColor="text-white"
      />

      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-dark-900/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
        <nav className="mx-auto flex items-center justify-between px-6 py-4 lg:px-10">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <a href="/" className="flex items-center gap-3 group">
              <div className="flex items-center gap-2.5">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-br from-brand-500 to-teal-500">
                  <i className="ri-home-gear-line text-white text-xl"></i>
                </div>
                <div className="flex flex-col leading-tight">
                  <span className="text-lg font-bold tracking-tight text-white">
                    Casa<span className="text-brand-400">ReNova</span><span className="text-teal-400">Plus</span>
                  </span>
                  <span className="text-[10px] text-gray-400 tracking-widest uppercase">Rénovation &amp; Services</span>
                </div>
              </div>
            </a>
          </div>

          {/* Desktop nav */}
          <div className="hidden lg:flex items-center gap-7">
            <a href="#services" className="text-sm font-medium text-gray-300 hover:text-brand-400 transition-colors whitespace-nowrap cursor-pointer">
              Services
            </a>
            <a href="/electricite" className="text-sm font-medium text-gray-300 hover:text-brand-400 transition-colors whitespace-nowrap cursor-pointer">
              Électricité
            </a>
            <a href="/sanitaire" className="text-sm font-medium text-gray-300 hover:text-brand-400 transition-colors whitespace-nowrap cursor-pointer">
              Sanitaire
            </a>
            <a href="/pompes-chaleur" className="text-sm font-medium text-gray-300 hover:text-brand-400 transition-colors whitespace-nowrap cursor-pointer">
              Chauffage
            </a>
            <a href="/ventilation" className="text-sm font-medium text-gray-300 hover:text-brand-400 transition-colors whitespace-nowrap cursor-pointer">
              Ventilation
            </a>
            <a href="/domotique" className="text-sm font-medium text-gray-300 hover:text-brand-400 transition-colors whitespace-nowrap cursor-pointer">
              Domotique
            </a>
            <a href="/renovation" className="text-sm font-medium text-gray-300 hover:text-brand-400 transition-colors whitespace-nowrap cursor-pointer">
              Rénovation
            </a>
            <a href="/maintenance" className="text-sm font-medium text-gray-300 hover:text-brand-400 transition-colors whitespace-nowrap cursor-pointer">
              Maintenance
            </a>
            <a href="/zones-intervention" className="text-sm font-medium text-brand-400 hover:text-brand-300 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1">
              <i className="ri-map-pin-line text-xs"></i>
              Zones
            </a>
            <a href="/recrutement" className="text-sm font-medium text-white whitespace-nowrap cursor-pointer flex items-center gap-1.5 bg-teal-500/20 hover:bg-teal-500/30 border border-teal-500/40 px-3 py-1.5 rounded-lg transition-all">
              <span className="w-1.5 h-1.5 rounded-full bg-teal-400 animate-pulse"></span>
              Recrutement
            </a>
            <a href="/presentation" className="text-sm font-medium text-gray-300 hover:text-brand-400 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1">
              <i className="ri-file-pdf-line text-xs"></i>
              Présentation
            </a>
          </div>

          {/* CTA + burger */}
          <div className="flex items-center gap-4">
            <a
              href="#contact"
              className="hidden lg:inline-flex items-center gap-2 rounded-lg bg-brand-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-brand-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              Devis gratuit
            </a>
            <button
              type="button"
              className="lg:hidden w-10 h-10 flex items-center justify-center text-white"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </nav>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="lg:hidden bg-dark-900/98 backdrop-blur-md border-t border-white/10">
            <div className="px-6 py-5 space-y-1">
              {[
                { label: 'Services', href: '#services' },
                { label: 'Électricité', href: '/electricite' },
                { label: 'Sanitaire', href: '/sanitaire' },
                { label: 'Chauffage', href: '/pompes-chaleur' },
                { label: 'Ventilation', href: '/ventilation' },
                { label: 'Domotique', href: '/domotique' },
                { label: 'Travaux de Rénovation', href: '/renovation' },
                { label: 'Maintenance', href: '/maintenance' },
                { label: 'Zones d\'intervention', href: '/zones-intervention' },
                { label: 'Blog', href: '/blog' },
                { label: 'Témoignages', href: '/temoignages' },
                { label: 'FAQ', href: '/faq' },
                { label: 'Recrutement', href: '/recrutement' },
                { label: 'Présentation PDF', href: '/presentation' },
                { label: 'Contact', href: '#contact' },
              ].map(item => (
                <a
                  key={item.href}
                  href={item.href}
                  className="block px-3 py-2.5 text-sm font-medium text-gray-300 hover:text-brand-400 hover:bg-white/5 rounded-lg transition-colors cursor-pointer"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#contact"
                className="block mt-4 rounded-lg bg-brand-500 px-5 py-3 text-center text-sm font-semibold text-white hover:bg-brand-600 transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Demander un devis gratuit
              </a>
            </div>
          </div>
        )}
      </header>
    </>
  );
}
